<ng-container>
  <ea-gridky-header
    [showTypeSelection]="type == 'lmnp'"
    [eaGridkyService]="gridkyService"
  ></ea-gridky-header>
  @if (product) {
    <ea-gridky-photo></ea-gridky-photo>
    <ea-gridky-subtitle></ea-gridky-subtitle>
    <ea-gridky-actions [url]="url"></ea-gridky-actions>
    <div class="product_title">
      <h3 class="fw-400">
        {{ product.typology | uppercase }} à
        <b>{{ product.priceInclTax | currency: 'EUR' : 'symbol' : '.0-0' }}</b>
        <span class="text-secondary fs-16 fw-500 mlxs"
          >(référence {{ product.reference }})</span
        >
      </h3>
    </div>
    <!-- <ea-gridky-performances></ea-gridky-performances> -->
    <ea-gridky-details class="mt-l"></ea-gridky-details>
    <!-- <ea-gridky-criteria class="flex-md-column mbm"></ea-gridky-criteria> -->
    <ea-gridky-info></ea-gridky-info>
  }
</ng-container>
@if (loading) {
  <pr-loader></pr-loader>
}
